import {TagsResponseType} from "@twigsby/client-data/lib/Types/Response/TagsResponseTypes";
import {SelectItemType} from "@twigsby/frontend-framework";

const ShapeTagSelectData = (tagData: any) : Array<SelectItemType> => {
    let selectOptions: Array<SelectItemType> = [];

    if(!tagData) return selectOptions;

    tagData.pages.map((page: TagsResponseType) =>
        page.data.map((tag) => selectOptions.push({label: tag.name, value: tag.id}))
    )

    return selectOptions;
}

export { ShapeTagSelectData }